module.exports = __webpack_public_path__ + "img/designsingapore-logo-white.3e74057b.png";